export const VOLUME_GRANULARITIES = [
  { accessor: 'daily', label: 'Daily' },
  { accessor: 'weekly', label: 'Weekly' },
  { accessor: 'monthly', label: 'Monthly' },
]

export const DEFAULT_GRANULARITY = 'weekly'

export const DISCONNECTION_REASONS = [
  {
    key: 'user-hangup',
    apiKey: 'user_hangup',
    label: 'User hang-up',
    color: 'var(--color-neutral)',
  },
  {
    key: 'transfer',
    apiKey: 'transfer',
    label: 'Transfer to human',
    color: 'var(--color-brand)',
  },
  { key: 'voicemail', apiKey: 'voicemail', label: 'Voicemail', color: 'var(--color-neutral)' },
  {
    key: 'agent-hangup',
    apiKey: 'agent_hangup',
    label: 'Agent hang-up',
    color: 'var(--color-success)',
  },
  { key: 'no-answer', apiKey: 'no_answer', label: 'No answer', color: 'var(--color-warning)' },
  { key: 'error', apiKey: 'error', label: 'Error', color: 'var(--color-critical)' },
]

export const DIRECTION_OPTIONS = [
  { label: 'All directions', value: 'all' },
  { label: 'Inbound', value: 'inbound' },
  { label: 'Outbound', value: 'outbound' },
]

export const SCHEDULED_CALL_OPTIONS = [
  { label: 'Included', value: 'all' },
  { label: 'Excluded', value: 'not_scheduled' },
  { label: 'Only', value: 'scheduled' },
]
